<template>
  <main class="home-page">
    <!-- Per-page SEO: unique title, meta description, and Open Graph tags for
         the Home_Page (Requirements 10.1, 10.2). -->
    <SeoHead :seo="content.seo" />

    <!--
      The Home_Page is composed of its section components rendered in order
      (Requirement 4.6, 4.7):
        1. HeroSection       — full-bleed imagery, innovation headline, CTA (4.1)
        2. ServicesSummary   — Service_Categories summary (4.2)
        3. FeaturedProjects  — projects sourced live from the Projects API (4.3)
        4. CredibilitySection — experience / clients / partners (4.4)
        5. ClosingCta        — closing CTA directing to the Contact page (4.5)

      Each section is responsive to the viewport via its own Vuetify grid and
      fluid styling, so the page reads as a single responsive column of
      full-width sections on every breakpoint (Requirement 4.7). Every section
      renders immediately so the page is complete without waiting on optional
      async data; FeaturedProjects degrades gracefully on its own (4.6).
    -->
    <HeroSection />
    <ServicesSummary />
    <FeaturedProjects />
    <CredibilitySection />
    <ClosingCta />
  </main>
</template>

<script>
// HomePage — the landing page served at the site root (Requirement 4).
//
// Composes the Home section components in order with a responsive, full-width
// stacked layout (Requirements 4.6, 4.7). All defined sections are rendered so
// the page is considered complete once mounted; each section sources its own
// copy/imagery from the structured Home content module
// (client/src/content/home.js) and FeaturedProjects pulls live from the
// Projects API without blocking the rest of the page.
//
// Uses the Options API to match the project's `plugin:vue/essential` ESLint
// preset (no `<script setup>`).
import home from '@/content/home'
import SeoHead from '@/components/SeoHead.vue'
import HeroSection from '@/components/home/HeroSection.vue'
import ServicesSummary from '@/components/home/ServicesSummary.vue'
import FeaturedProjects from '@/components/home/FeaturedProjects.vue'
import CredibilitySection from '@/components/home/CredibilitySection.vue'
import ClosingCta from '@/components/home/ClosingCta.vue'

export default {
  name: 'HomePage',
  components: {
    SeoHead,
    HeroSection,
    ServicesSummary,
    FeaturedProjects,
    CredibilitySection,
    ClosingCta,
  },
  data () {
    return {
      // Home_Page content (SEO metadata) from the structured content module.
      content: home,
    }
  },
}
</script>

<style lang="scss" scoped>
.home-page {
  // Sections are full-width and stack in a single responsive column; each
  // section manages its own internal grid and spacing.
  display: block;
}
</style>
